import { ReactElement, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { lazy } from 'utils/generic/lazy';
import { EBetslipType } from 'interfaces/betslip';
import { getBetslipType, getEditBet } from 'store/selectors/betslip';
import { getUser } from 'store/selectors/user-data';

const { _FreeBetManager } = lazy(
  () =>
    import(
      /* webpackChunkName: "_FreeBetManager" */ 'newelements/_Betslip/managers/FreeBetManager/manager'
    )
);

const { FreeBetManagerBetslipTypeBaseSlice } = lazy(
  () =>
    import(
      /* webpackChunkName: "FreeBetManagerBetTypeBaseSlice" */ 'newelements/_Betslip/managers/FreeBetManager/BetslipTypeBaseSlices'
    )
);

const PRELOAD_CACHE: Record<EBetslipType, boolean> = {
  [EBetslipType.BASIC]: false,
  [EBetslipType.ADVANCED]: false
};

export const FreeBetManager = (): ReactElement | null => {
  const editBet = useSelector(getEditBet);
  const type = useSelector(getBetslipType);
  const { has_free_bets } = useSelector(getUser);
  const shouldFreeBetMount = !editBet?.active && has_free_bets;

  if (shouldFreeBetMount && !PRELOAD_CACHE[type]) {
    prefetchChunks(type);
  }

  if (shouldFreeBetMount) {
    return (
      <Suspense>
        <_FreeBetManager />
        <FreeBetManagerBetslipTypeBaseSlice />
      </Suspense>
    );
  }

  return null;
};

const prefetchChunks = (type: EBetslipType) => {
  PRELOAD_CACHE[type] = true;

  if (type === EBetslipType.ADVANCED) {
    import(
      /* webpackChunkName: "FreeBetBetslipTypeSliceAdvanced" */ /* webpackPreload: true */ 'newelements/_Betslip/managers/FreeBetManager/BetslipTypeBaseSlices/advanced'
    );
  } else {
    import(
      /* webpackChunkName: "FreeBetBetslipTypeSliceBasic" */ /* webpackPreload: true */ 'newelements/_Betslip/managers/FreeBetManager/BetslipTypeBaseSlices/basic'
    );
  }
};
